<div
  class="result-action-buttons"
  [class.result-action-buttons--muted]="muted()"
>
  <a
    routerLink="."
    [queryParams]="editQueryParams()"
    [title]="complete() ? 'Edit result' : 'Enter result'"
  >
    <img ngSrc="img/actions/pencil.svg" alt="Edit" width="16" height="18" />
  </a>
  @if (deleteQueryParams()) {
    <a title="Delete result" routerLink="." [queryParams]="deleteQueryParams()">
      <img ngSrc="img/actions/bin.svg" alt="Delete" width="16" height="18" />
    </a>
  }
</div>
